import React from 'react'

import clsx from 'clsx'

import Paper from 'components/Paper'

/** @type {import("./types").default} */
const Card = ({ children, className }) => {
  return (
    <Paper data-testid="listing-item" className={clsx('ListingCard', className)}>
      {children}
    </Paper>
  )
}

export default Card
